<template>
  <div class="logo">
    <img src="../assets/brand/logo-icon.svg" style="height: 48px">
  </div>
</template>

<script>
export default {
  name: 'logo'
}
</script>

<style scoped>
  .logo {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
